import { useTranslation } from 'react-i18next';
import { ShoppingBag, ArrowRight } from 'lucide-react';
import LangToggle from './LangToggle';
import { WHATSAPP } from './constants';
import { adminUrl } from '../../utils/subdomain';

const NAV_LINKS = [
  { key: 'home', href: '#home' },
  { key: 'features', href: '#features' },
  { key: 'howItWorks', href: '#how-it-works' },
];

export default function Header() {
  const { t } = useTranslation();

  return (
    <header className="sticky top-0 z-20 bg-white/80 backdrop-blur border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
        <a href="#home" className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-violet-500 to-purple-600 shadow-lg shadow-violet-500/10 flex items-center justify-center">
            <ShoppingBag size={18} className="text-white" />
          </div>
          <div className="leading-tight">
            <p className="font-bold text-gray-900 text-lg tracking-tight">{t('landing.brand.name')}</p>
            <p className="text-[11px] text-gray-400 -mt-0.5">{t('landing.brand.tagline')}</p>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-500">
          {NAV_LINKS.map(({ key, href }) => (
            <a key={key} href={href} className="hover:text-violet-600 transition-colors">
              {t(`landing.nav.${key}`)}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <LangToggle />
          <a
            href={adminUrl()}
            className="text-xs sm:text-sm font-semibold text-gray-600 hover:text-violet-600 px-2 sm:px-3 py-2 rounded-xl transition-colors whitespace-nowrap"
          >
            {t('landing.nav.login')}
          </a>
          <a
            href={WHATSAPP}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 bg-gradient-to-r from-violet-600 to-purple-600 text-white text-xs sm:text-sm font-semibold px-3 sm:px-4 py-2 rounded-xl shadow-lg shadow-violet-500/10 hover:shadow-violet-500/20 hover:scale-[1.03] transition-all whitespace-nowrap"
          >
            {t('landing.nav.ctaBtn')}
            <ArrowRight size={14} />
          </a>
        </div>
      </div>
    </header>
  );
}
